import React, { useState, useEffect } from 'react';
import { performanceAPI } from '../services/api';
import { Activity, Database, Zap, AlertTriangle } from 'lucide-react';
import './PerformancePage.css';

function PerformancePage() {
  const [metrics, setMetrics] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadMetrics();
  }, []);

  const loadMetrics = async () => {
    try {
      const response = await performanceAPI.getMetrics();
      setMetrics(response.data);
    } catch (error) {
      console.error('Error loading performance metrics:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="performance-page">
      <div className="page-header">
        <h1 className="page-title">
          <Activity className="title-icon" />
          Performance Monitoring
        </h1>
        <p className="page-description">
          System health and performance metrics
        </p>
      </div>

      <div className="metrics-grid">
        <div className="metric-card">
          <Database className="metric-icon" />
          <h3>Database Performance</h3>
          <div className="metric-value">{metrics?.database?.query_time || 0}ms</div>
        </div>

        <div className="metric-card">
          <Zap className="metric-icon" />
          <h3>Cache Hit Rate</h3>
          <div className="metric-value">{metrics?.cache?.hit_rate || 0}%</div>
        </div>

        <div className="metric-card">
          <AlertTriangle className="metric-icon" />
          <h3>System Alerts</h3>
          <div className="metric-value">{metrics?.alerts?.count || 0}</div>
        </div>
      </div>
    </div>
  );
}

export default PerformancePage;